import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const saltData = {
  freeflow: {
    name: 'Free Flow Salt',
    image: '/images/salt/freeflow.webp',
    description: 'Free Flow Salt, commonly used in modern Tamil households, is a refined version of natural sea salt processed to remove moisture and prevent clumping. It is mainly sourced from salt pans in Tuticorin, Vedaranyam, and Nagapattinam, Tamil Nadus coastal regions known for salt production.While convenient for daily cooking, free flow salt is typically iodized, which many Tamil families believe helps in preventing thyroid issues. It is easy to store, measures accurately, and blends well in dishes like sambar, rasam, and poriyal. Though not traditional like rock salt, it has become a kitchen essential for its ease of use and long shelf life.',
  },
  crystal: {
    name: 'Crystal Salt',
    image: '/images/salt/crystal.webp',
    description: 'Crystal Salt, known as Kal Uppu (கல் உப்பு) in Tamil, is a natural, unrefined sea salt harvested from coastal salt pans in regions like Thoothukudi, Vedaranyam, and Marakkanam. It is sun-dried, minimally processed, and often crushed at home or in local mills before use.Tamil people traditionally prefer crystal salt for its purity and mineral richness, believing it supports better digestion, enhances taste, and maintains body balance. It is commonly used in pickles, rasam, and traditional snacks, and is valued for its cooling properties and absence of chemical additives. Many households use it during Poojas and festival cooking as a more sattvic, natural choice',
  },
  pink: {
    name: 'Pink Salt (Crystal)',
    image: '/images/salt/pink.webp',
    description: 'Pink Salt, also known as Himalayan Salt, is a naturally occurring mineral-rich rock salt with a rosy tint, increasingly popular in Tamil Nadu’s health-conscious households. Though not native to the region, it is valued for being unrefined, chemical-free, and rich in trace minerals like iron, calcium, and magnesium.Tamil users believe pink salt helps balance electrolytes, regulate blood pressure, and improve digestion. It is often used as a healthier alternative to refined salt in salads, detox drinks, and light cooking. Some also use it during fasting days or Ayurvedic diets, seeing it as a body-cleansing and calming salt option.'
  },
};

const SaltDetail = () => {
  const { type } = useParams();
  const salt = saltData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/salts');
    };

  if (!salt) return <h2>Salt product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${salt.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Salts Products</button>
          <h2>{salt.name}</h2>
          <p>{salt.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default SaltDetail;
